module.exports = __webpack_public_path__ + "static/howlongistheline-c1b62ea443b99621b67e64eb5edadbf4.png";